<template>
    <div class="flex transfers">
        <div class="left">
            <el-tooltip
                class="item"
                effect="dark"
                content="加入算法排车"
                placement="top"
            >
                <el-button
                    @click="moveDown"
                    class="up-down"
                    type="text"
                    icon="el-icon-bottom"
                ></el-button>
            </el-tooltip>
            <el-tooltip
                class="item"
                effect="dark"
                content="移除算法排车"
                placement="top"
            >
                <el-button
                    @click="moveUp"
                    class="up-down"
                    type="text"
                    icon="el-icon-top"
                ></el-button>
            </el-tooltip>
            <span class="left-info">
                <span
                    >排单编码：<span class="content">{{
                        lineHeaderData.lineCode
                    }}</span></span
                >
                <span
                    >排单状态：<span class="content">{{
                        lineHeaderData.lineStatusName
                    }}</span></span
                >
                <span
                    >失败原因：<span class="content">{{
                        lineHeaderData.orderFailReason
                    }}</span></span
                >
                <span class=""
                    >单量：<span class="content">{{
                        lineHeaderData.totalOrderNum
                    }}</span></span
                >
                <span class=""
                    >总里程(Km)：<span class="content">{{
                        lineHeaderData.totalMileage
                    }}</span></span
                >
                <span
                    >方量(m³)：<span class="content">{{
                        lineHeaderData.totalVolume
                    }}</span></span
                >
                <span
                    >方公里成本(元)：<span class="content">{{
                        lineHeaderData.volumeMileageAveCost
                    }}</span></span
                >
                <i class="el-icon-view" @click="handleDetailStatistics"></i>
            </span>
        </div>
        <div class="right">
            <div class="btn-content">
                <el-button
                    type="primary"
                    class="btn-content_button"
                    v-show="showScheduleBtn"
                    @click="adjustBtn"
                    >调整</el-button
                >
                <span v-show="showScheduleBtn" class="refresh_button"
                    ><i class="el-icon-refresh" @click="submitArrange"></i
                ></span>
            </div>
        </div>
        <el-dialog
            title="查看明细"
            :visible.sync="detailVisible"
            append-to-body
            width="65%"
        >
            <el-table border :data="detailStatistics">
                <el-table-column
                    property="customerItemCode"
                    label="客户商品编码"
                    width="130"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="itemName"
                    label="商品名称"
                    width="300"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="itemClass"
                    label="商品分类"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="planQty"
                    label="数量"
                    sortable
                ></el-table-column>
                <el-table-column
                    property="volume"
                    label="方量(m³)"
                    sortable
                ></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
import _ from '@/components/lots/utils';
import { rowCarCheck, addOrderCheck, verifyLBX, getMesTip, appointmentCheck, backwardVerification } from '../../../utils/dispatchCenter.js';
import { getDetailStatistics } from '../../../api/sieveSingleCenter';

const PRIVILEGE_MOVE_CODE = '11010010';
const DISPATCH_STATUS_IN_TRANSIT = 40; // 发车单状态-在途

export default {
    props: {
        flag: {
            type: String,
            default () {
                return '';
            }
        },
        tarSelRoot: {
            type: Object,
            default () {
                return {};
            }
        },
        lineHeaderData: {
            type: Object,
            default () {
                return {};
            }
        },
        totalSuanfaTargetData: {
            type: Array,
            default () {
                return [];
            }
        },
        mulTotalData: { // 上表格应该展示的所有数据（1000条的分页）
            type: Array,
            default () {
                return [];
            }
        },
        checkedSourceList: { // 需要校验的来源数据
            type: Array,
            default () {
                return [];
            }
        },
        appointmentSiteCodeWhiteList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            identify: this.flag,
            confirmLoading: false,
            detailVisible: false,
            detailStatistics: [],
            showConfirmBtn: false,
            showTransBtn: false,
            showScheduleBtn: true,
            isDisable: false,
            value: '',
            transTreeFilter: [],
            transferVerifyLBXOrderRes: [],
            transferVisi: false,
            taskList: []// 运输单集合
        };
    },
    computed: {
        isPrivilege: function () { // 加入发车单/移除发车单 时使用，特权模式
            const auths = this.$_has(PRIVILEGE_MOVE_CODE);
            return auths;
        }
    },
    methods: {
        handleDetailStatistics () {
            this.detailVisible = true;
            const taskNoList = this.taskList.map(item => item.taskNo);
            getDetailStatistics(taskNoList).then(res => {
                if (res) {
                    this.detailStatistics = res.data.list || [];
                }
            });
        },
        newDispOrder () {
            this.$emit('newDispOrder');
        },
        intelliArrange () {
            this.$emit('intelArr');
        },
        // 刷新
        submitArrange () {
            this.$emit('getCarList');
        },
        // 调整
        adjustBtn () {
            this.$emit('adjust-btn');
        },
        moveUp () {
            this.$emit('cancel');
        },
        moveDown () {
            if (this.checkedSourceList.length === 0) return this.$message.warning('请至少勾选一条数据');
            const rows2Transfer = this.checkedSourceList;
            if (+this.tarSelRoot.dispatchStatus >= DISPATCH_STATUS_IN_TRANSIT) {
                for (let i = 0; i < rows2Transfer.length; i++) {
                    if (rows2Transfer[i].logisticMode === 'WT') return this.$message.warning('发车单不是在途前的状态，不允许加仓配分离订单');
                }
            }
            if (this.isPrivilege && rows2Transfer.some(item => item.logisticMode === 'WT') && rows2Transfer.some(item => item.scanNum > 0) && rows2Transfer.every(item => +item.dispatchType !== 0)) {
                return this.$message.warning('直通宝已扫码，请在直通宝完成后续操作');
            }
            let rowCarCheckRes = '';
            const realTotalData = this.mulTotalData;
            const verifyLBXRes = verifyLBX(rows2Transfer, realTotalData);
            if (this.totalSuanfaTargetData.length <= 0) {
                rowCarCheckRes = rowCarCheck(rows2Transfer);
            } else {
                rowCarCheckRes = rowCarCheck(this.taskList);
                if (!rowCarCheckRes) rowCarCheckRes = rowCarCheck(rows2Transfer, this.taskList[0], this.taskList);
                if (!rowCarCheckRes) rowCarCheckRes = addOrderCheck(this.taskList, rows2Transfer);
            }
            if (rowCarCheckRes) {
                return this.$message.warning(rowCarCheckRes);
            } else if (_.isObject(verifyLBXRes)) {
                return getMesTip(verifyLBXRes, this);
            } else {
               this.continueMoveDown(verifyLBXRes);
            }
        },
        async continueMoveDown (verifyLBXRes) {
            backwardVerification(verifyLBXRes, this);
            const customerOrderNoList = appointmentCheck(verifyLBXRes, this.appointmentSiteCodeWhiteList);
            if (customerOrderNoList.length) {
                await this.$confirm(`以下客户订单号需要先预约才能排车<br/>${customerOrderNoList.join('<br/>')}`, '提醒', {
                    confirmButtonText: '剔除后加入',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    // 剔除不符合的tk单
                    verifyLBXRes = verifyLBXRes.filter(x => !customerOrderNoList.includes(x.customerOrderNo));
                    const totalTargetDataNew = [
                        ...verifyLBXRes
                    ];
                    const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                    const totalDataNew = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                    this.$emit('totalSuanfaDataChange', totalTargetDataNew, totalDataNew, true);
                }).catch(() => {
                    return false;
                });
            } else {
                const totalTargetDataNew = [
                    ...verifyLBXRes
                ];
                const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                const totalDataNew = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                this.$emit('totalSuanfaDataChange', totalTargetDataNew, totalDataNew, true);
            }
        }
    },
    watch: {
        totalSuanfaTargetData: {
            handler (n, o) {
                this.taskList = [];
                this.totalSuanfaTargetData.forEach(item => {
                    item.lineOrderResponseList.forEach(item => {
                        this.taskList.push(item);
                    });
                });
            },
            deep: true
        }
    }
};
</script>
<style lang="less">
.transfers {
    .dialog-footer {
        text-align: right;
        margin-top: 15px;
    }
    .up-down {
        font-size: 18px;
        margin-left: 0px;
        margin-right: 10px;
    }
    .right {
        width: 100px;
        .btn-content {
            display: inline-block;
        }
        .btn-content_button {
            margin-left: 10px;
        }
        .refresh_button {
            margin-left: 6px;
            cursor: pointer;
            color: #00bcbf;
        }
    }
}
</style>
